import styled from 'styled-components'

/** @component */
export default styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
`
